import { useGetUserQuery } from '@src/generated/hooks';

/**
 * @name useUser
 * @description tbd...
 */
export function useUser(email?: string) {
  const { data, error, loading } = useGetUserQuery({
    variables: {
      email: email ?? '',
    },
  });

  return {
    errorUser: error,
    isLoadingUser: loading,
    user: data?.user,
  };
}
